import { ITheme } from "../generated/Api";

export const localStorageConstants = {
  USER_EMAIL: "@berserker/user_email",
  USER_UID: "@berserkermail/uid",

  REFERRAL_CODE: "@berserkermail/referral_code",

  INTERNAL_USER_UID: "@berserkermail/internal_uid",
  INTERNAL_TOKEN: "@berserkermail/internal_token",

  ADMIN_UID: "@berserkermail/admin_uid",
  ADMIN_AVATAR: "@berserkermail/admin_avatar",

  EXTRA_CARRIAGE: "@berserker/add_extra_carriage",
  FIRST_LINE_TITLE: "@berserker/title_first_line",
  DRAFT_EMAIL_BODY: "@berserker/draft_email_body",
  DRAFT_EMAIL_SUBJECT: "@berserker/draft_email_subject",
  DRAFT_EMAIL_LABELS: "@berserker/draft_email_labels",
  DRAFT_EMAIL_SPLIT_SUBJECT: "@berserker/draft_email_split_subject",
  DRAFT_EMAIL_SPLIT_MODE: "@berserker/draft_email_split_mode",
  DRAFT_INTEREST_TAGS: "@berserker/draft_interest_tags",
  SCHEDULE_INTERVAL: "@berserker/schedule_interval",
  DRAFT_EMAIL_FONT: "@berserker/draft_email_font",
  DRAFT_EMAIL_FONT_SIZE: "@berserker/draft_email_font_size",
  DRAFT_EMAIL_ZOOM: "@berserker/draft_email_zoom",
  LAST_NOTE_CATEGORY: "@berserker/last_note_category",

  ATOM_CURRENT_RECIPIENTS: "@berserker/atoms/current_recipients",
  ATOM_RECIPIENT: "@berserker/atoms/recipient",

  SEARCH_INPUT: "@berserker/search_input",

  MANAGE_SAVED_SEARCHES_GOT_IT: "@berserker/manage_saved_searches_got_it",

  USER_TOKEN: "@berserker/token",

  CAMPAIGN_NOTE_ZOOM: "@berserker/campaign_note_zoom",
};

export const NO_COUNTRY = null;

export const COPYRIGHT_COPY =
  "© Learnistic LLC 2021. BerserkerMail is a Learnistic LLC service. All rights reserved.<br />13506 Summerport Village Parkway #714, Windermere, FL 34786 — ‭(407) 377-7721‬‬‬";

export const sessionStorageConstants = {
  ADMIN_UID: "@berserker/admin_uid",
};

export const LEARNISTIC_UID = "SiE6NIgH8O4RPLf3zMgF57pZZ0GbdAr5";

export const INTERNAL_USER_FOR_AUTO_TEXT_STYLE =
  "6CHQE9afQi2JUHk8bjpXDQi67fhTJExU"; // Troy

export const INTERNAL_UIDS_BETA = [
  "6CHQE9afQi2JUHk8bjpXDQi67fhTJExU", // Troy
  "O2oy99u9WR0GhuKDHUEOsC4opHBH7Nga", // Nicole
  "2jbmvFj-C3Tt9Mb2od69dM_BiwMrTF1f", // Gabiru
  "iCnbr5BEnIrDkRcRtAHOwBIH0XkP8fAN", // Thales
  "HLB3TrO4ALqXrOLnAs8h5jnh7CMB5Z9q", // Roger
  "mJmEO3B52_mBwYiRe4USfbFpaPHOJTIP", // Persuasive page Support
  "7TIDNdx4ewqIi5CYtE1ncllKCF4IoAPE", // Daniel Throssell
  "EqZiuC0v05sBLyVNiKKs3gsk2nt7Wds3", // Lance
  "Z_KcGuEgmfdZlOl4yiD3ylCV6sjEO8vl", // Sara
];

export const TEST_USERS = [
  "6CHQE9afQi2JUHk8bjpXDQi67fhTJExU", // Troy
  "QDtpVb_rRjDhQrUzG7wsiJTbr-H5xGMV", // Ben
  "O2oy99u9WR0GhuKDHUEOsC4opHBH7Nga", // Nicole
  "2jbmvFj-C3Tt9Mb2od69dM_BiwMrTF1f", // Gabiru
  "HLB3TrO4ALqXrOLnAs8h5jnh7CMB5Z9q", // Sara
];

export const themes: ITheme[] = [
  {
    border: "#BCB4AA",
    color: "#FFFFFF",
    textColor: "#333333",
    placeholderColor: "#979797",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
  },
  {
    border: "#BCB4AA",
    color: "#F8F1E4",
    textColor: "#000000",
    placeholderColor: "#a3a7ac",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
  },
  {
    border: "#BCB4AA",
    color: "#ECF8E4",
    textColor: "#000000",
    placeholderColor: "#a3a7ac",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
  },
  {
    border: "#4A494F",
    color: "#555555",
    textColor: "#f0f0f0",
    placeholderColor: "#a4a9ad",
    titleColor: "#ffffff",
    titlePlaceholderColor: "#ced4da",
  },
  {
    border: "#4A494F",
    color: "#000000",
    textColor: "#f0f0f0",
    placeholderColor: "#ced4da",
    titleColor: "#ffffff",
    titlePlaceholderColor: "#ced4da",
  },
];
